<div class="wrap-x wrap-l">
    <div class="w-12">
        <div class="p-t-1 p-b-1 center pos-relative overflow-hidden">
            <h1 class="p-l-12 p-r-12 p-l-4-s p-r-4-s pos-relative w-12-s title-decoration h2 p-t-5-s b-t-s b-col-42-s"
                *iCms="'title' of component">
            </h1>
        </div>
        <swiper [slidesPerView]="[2.2, 4.5, 6.4, 6.4][client.sizeId]"
                [spaceBetween]="10"
                class="m-t m-t-6-s overflow-visible"
                [observeParents]="true">$index
            @for (quicklink of component.quicklinks; track $index; let i = $index) {
            <ng-template swiperSlide>
                <div class="center">
                    <div class="w-12 ratio-1-1 overflow-hidden">
                        <href [link]="quicklink.url">
                            <shell></shell>
                            @if (quicklink.image) {
                            <img class="rf z-1"
                                 [image]="quicklink.image">
                            }
                            @if (quicklink.contentVariant === contentVariant.video) {
                            @if (quicklink.contentVideoProvider === contentVideoProvider.vimeo) {
                            <vimeo-player class="rf z-2"
                                          [video-id]="quicklink.contentVideoId"
                                          [background]="true"
                                          [loop]="true">
                            </vimeo-player>
                            }
                            @if (quicklink.contentVideoProvider === contentVideoProvider.youtube) {
                            <youtube-player class="rf z-2"
                                            [video-id]="quicklink.contentVideoId">
                            </youtube-player>
                            }
                            }
                        </href>
                    </div>
                    <href [link]="quicklink.url">
                        <button class="button-inline m-t-3">
                            <span class="button__body"
                                  *iCms="'title' of quicklink">
                            </span>
                        </button>
                    </href>
                </div>
            </ng-template>
            }
        </swiper>
    </div>
</div>